import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  MultifactorEnrolPageComponent as AuthMultifactorEnrolPageComponent,
  MULTIFACTOR_CURRENT_USER_DOC,
} from '@principle-theorem/ng-auth';
import { PageSplashComponent } from '@principle-theorem/ng-principle';
import { OrganisationService } from '@principle-theorem/ng-principle-shared';

@Component({
  selector: 'pr-multifactor-enrol-page',
  templateUrl: './multifactor-enrol-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: MULTIFACTOR_CURRENT_USER_DOC,
      deps: [OrganisationService],
      useFactory: (organisation: OrganisationService) => organisation.user$,
    },
  ],

  imports: [PageSplashComponent, AuthMultifactorEnrolPageComponent],
})
export class MultifactorEnrolPageComponent {}
